import React from "react";
import styled from "styled-components";

const ButtonStyle = styled.button`
  cursor: pointer;
  outline: none;
  border: 2px solid #1b2d35;
  color: #1b2d35;
  background-color: transparent;
  padding: 0.3em 1em;
  display: inline-block;
  text-align: center;
  text-decoration: none;
  font-size: 20px;
  font-family: "toyota_displaybold", "Helvetica Neue Light",
    "HelveticaNeue-Light", "Helvetica Neue", Calibri, Helvetica, Arial;
  text-transform: uppercase;
  position: relative;
  -webkit-transition: color 0.2s, border-color 0.7s;
  transition: color 0.2s, border-color 0.7s;
  overflow: hidden;
  span {
    color: inherit;
    position: relative;
    z-index: 2;
}
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    bottom: 0;
    width: 0;
    transform: translateX(-50%);
    background-color: #1b2d35;
    z-index: 1;
    opacity: 0;
    transition: width 0.2s cubic-bezier(0.8, 0, 0, 0),
      opacity 0.2s cubic-bezier(0.8, 0, 0, 0);
  }
  &:hover {
    color: #ffffff;
    &:after {
      width: 100.5%;
      opacity: 1;
      content: "";
      position: absolute;
      top: 0;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      background-color: #1b2d35;
      z-index: 1;
      transition: width 0.2s cubic-bezier(0.8, 0, 0, 0),
        opacity 0.2s cubic-bezier(0.8, 0, 0, 0);
    }
  }
`;

export default class TButton extends React.Component {
  render() {
    return <ButtonStyle onClick={this.props.onClick}><span>{this.props.value}</span></ButtonStyle>;
  }
}



// WEBPACK FOOTER //
// ./src/component/tbutton.js